"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class ConnectionAlreadyRejectedError extends client_library_1.ExtendableError {
    constructor() {
        super('Connection has already been rejected');
    }
}
exports.default = ConnectionAlreadyRejectedError;
//# sourceMappingURL=ConnectionAlreadyRejectedError.js.map